import moment from 'moment-timezone';
import { convertUTCtoUserTimeZoneMoment } from 'src/utilities/DateTimeUtilities';
import { isIcebergVersion } from 'src/components/star-grid/utils/versionAvailability';
import type { DataSyncText } from 'src/components/star-grid/hooks/useDataSyncText';
import { PnlDataVersion, SnapshotDateRange } from 'src/components/star-grid/reportSelectors.types';
import { VERSION_DATE_PRESETS } from 'src/components/star-grid/versionDateFilterConstants';

export const versionCountText = (pattern: string, count: number, total = 0): string =>
  pattern.replace('{count}', count.toLocaleString()).replace('{total}', total.toLocaleString());

export const versionRangeTitle = (range: SnapshotDateRange, text: DataSyncText): string =>
  text(VERSION_DATE_PRESETS.find((preset) => preset.id === range.preset)?.labelKey ?? 'versionCustomRange');

export const versionDate = (version: PnlDataVersion): moment.Moment => {
  const date = moment.utc(version.as_of, moment.ISO_8601, true);
  return date.isValid() ? convertUTCtoUserTimeZoneMoment(date.toISOString()) : date;
};

export const versionRowPresentation = (version: PnlDataVersion) => {
  const date = versionDate(version);
  const snapshot = isIcebergVersion(version) && date.isValid();
  return {
    displayLabel: snapshot ? date.format('YYYY-MM-DD HH:mm:ss z') : version.label,
    description: undefined,
    dateTime: date.isValid() ? date.toISOString() : undefined
  };
};
